export const enum OBJECTPROPERTYTYPE {
  Text = 1,
  TextLong = 2,
  Boolean = 3,
  List = 4,
}

export interface ObjectPropertyOption {
  name: string;
  value: string;
}

export class ObjectProperty {
  name: string;
  editType: OBJECTPROPERTYTYPE;
  canEdit: boolean;
  options: ObjectPropertyOption[];

  constructor(name: string, editType: OBJECTPROPERTYTYPE, canEdit: boolean = true) {
    this.name = name;
    this.editType = editType;
    this.canEdit = canEdit;
    this.options = [];
  }

  addOption(value: string, name: string) {
    let option: ObjectPropertyOption = {
      value: value,
      name: name,
    };
    this.options.push(option);
  }
}
